type ApiErrorLike = {
  response?: {
    data?: { message?: string | string[] };
    message?: string | string[];
  };
  message?: string | string[];
};

function normalizeMessage(message: unknown): string | undefined {
  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }
  if (Array.isArray(message)) {
    const joined = message
      .filter(
        (part): part is string => typeof part === "string" && !!part.trim(),
      )
      .map((part) => part.trim())
      .join(", ");
    return joined || undefined;
  }
  return undefined;
}

function isAxiosTransportMessage(message: string): boolean {
  return /^request failed with status code \d+/i.test(message);
}

/**
 * Prefer a backend-provided message; otherwise use the caller fallback.
 * Avoids surfacing generic Axios text like "Request failed with status code 400".
 * Accepts Nest-style string | string[] messages.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!error) {
    return fallback;
  }

  const apiError = error as ApiErrorLike;
  const backendMessage =
    normalizeMessage(apiError.response?.data?.message) ||
    normalizeMessage(apiError.response?.message);

  if (backendMessage) {
    return backendMessage;
  }

  // Top-level Error.message is only used when it is not an Axios transport string.
  const topLevel = normalizeMessage(apiError.message);
  if (topLevel && !isAxiosTransportMessage(topLevel)) {
    return topLevel;
  }

  return fallback;
}
